import { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import { AppRoutePath } from '@ocx-app/pages/AppRoutePath';

import { Typography, TypographyProps } from '@ocx/ui';

import { messages } from '../../signup.messages';

export const ChangeNumberLink = (props: TypographyProps) => {
  const navigate = useNavigate();
  const handleClick = useCallback(() => navigate(AppRoutePath.AuthWildcard, { replace: true }), [navigate]);

  return (
    <Typography
      onClick={handleClick}
      variant="caption"
      color="primary"
      align="center"
      sx={{ cursor: 'pointer' }}
      {...props}>
      <FormattedMessage {...messages['signup:change-number-link:text']} />
    </Typography>
  );
};
